module.exports = __webpack_public_path__ + "static/media/layers.fbbdf37f.svg";